import React, { useEffect, useState } from "react";
import { ExternalLink } from "lucide-react";
import styles from "./CatalogRowPreview.module.css";

const normalize = value => String(value || "").replace(/\s/g, "").toUpperCase();

// [[Catalog Assets]] Saved cards only; never start collection from detail rows.
export default function CatalogRowPreview({ partNumber, manufacturer, materials = [] }) {
    const cards = materials.filter(item => item.catalog_product_id);
    const candidates = manufacturer?.trim()
        ? cards.filter(item => [item.manufacturer, ...(item.manufacturer_aliases || [])].some(value => normalize(value) === normalize(manufacturer)))
        : cards;
    const material = candidates.find(item => item.verified) || candidates.find(item => item.assets?.some(asset => asset.kind === "image" && asset.stored)) || candidates[0];
    const asset = material?.assets?.find(item => item.kind === "image" && item.stored);
    const [image, setImage] = useState(null);
    useEffect(() => {
        setImage(null);
        if (!asset?.url) return undefined;
        const controller = new AbortController();
        let objectUrl;
        fetch(asset.url, { signal: controller.signal })
            .then(response => {
                if (!response.ok) throw new Error("Image unavailable");
                return response.blob();
            }).then(blob => {
                if (controller.signal.aborted) return;
                objectUrl = URL.createObjectURL(blob);
                setImage({ source: asset.url, url: objectUrl });
            }).catch(() => {});
        return () => { controller.abort(); if (objectUrl) URL.revokeObjectURL(objectUrl); };
    }, [asset?.url]);
    if (!material) return null;
    const params = new URLSearchParams({ productId: material.catalog_product_id });
    return <a className={`${styles.link} ${material.verified ? styles.verified : styles.unverified}`} href={`/?${params}`} target="_blank" rel="noopener noreferrer"
        title={`${material.verified ? "Проверена" : "Не проверена"}. Открыть в каталоге: ${partNumber}${material.manufacturer ? ` — ${material.manufacturer}` : ""}`}
        onClick={event => event.stopPropagation()}>
        {image?.source === asset?.url && image?.url && <img className={styles.thumbnail} src={image.url} alt={partNumber} onError={() => setImage(null)} />}
        <span>В каталог</span><ExternalLink size={14} aria-hidden="true" />
    </a>;
}
